import React from 'react'
import Navbar from '../inc/Navbar'
import Jaquarpage from './Jaquarpage'
import {Link} from "react-router-dom";

function JaquarProductpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
         <br/>
           <div className='jaquarpage'>
                        <div className="album py-1">
                            <div className="container mt-3">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Jaquar Page</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
        <Jaquarpage/>
        <br/>
    </div>
  )
}

export default JaquarProductpage